module.exports = __webpack_public_path__ + "img/4-1.89958e9b.png";